import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["progressBar", "progressText", "stepList", "errorMessage", "retryButton"]
  static values = { instanceId: String }

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "InstanceProvisioningChannel", instance_id: this.instanceIdValue },
      {
        received: (data) => this.handleUpdate(data),
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleUpdate(data) {
    // Always update progress for any message with progress data
    if (data.progress !== undefined) {
      this.updateProgress(data.progress, data.status)
    }

    // Handle completion — auto-reload to show the full instance page
    if (data.status === "complete") {
      setTimeout(() => window.location.reload(), 2000)
    }

    // Handle failure — show error message and retry button
    if (data.status === "failed") {
      this.showError(data.error)
    }
  }

  updateProgress(percent, status) {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.value = percent
      this.progressBarTarget.setAttribute("aria-valuenow", percent)
    }

    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = this.stepLabel(status)
    }

    this.highlightSteps(status)
  }

  showError(message) {
    // Switch progress bar to error color
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.classList.remove("progress-primary")
      this.progressBarTarget.classList.add("progress-error")
    }

    // Switch completed steps to error color
    if (this.hasStepListTarget) {
      this.stepListTarget.querySelectorAll(".step-primary").forEach((step) => {
        step.classList.remove("step-primary")
        step.classList.add("step-error")
      })
    }

    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove("hidden")
    }
    if (this.hasRetryButtonTarget) {
      this.retryButtonTarget.classList.remove("hidden")
    }
  }

  stepLabel(status) {
    const labels = {
      // Standard provisioning steps
      creating_droplet: "Creating server...",
      waiting_for_ssh: "Waiting for server to boot...",
      configuring_dns: "Configuring DNS...",
      setting_up_code: "Setting up code...",
      configuring_instance: "Configuring instance...",
      installing_dependencies: "Installing dependencies...",
      verifying_health: "Verifying health...",
      complete: "Ready!",
      failed: "Provisioning failed",
      // Clone-specific steps
      creating_snapshot: "Snapshotting source instance...",
      waiting_for_snapshot: "Waiting for snapshot...",
      updating_identity: "Updating instance identity...",
      cleanup: "Cleaning up...",
    }
    return labels[status] || status
  }

  highlightSteps(currentStep) {
    if (!this.hasStepListTarget) return

    const steps = this.stepListTarget.querySelectorAll("[data-step]")
    let found = false

    steps.forEach((step) => {
      if (found) {
        step.classList.remove("step-primary")
      } else {
        step.classList.add("step-primary")
        if (step.dataset.step === currentStep) {
          found = true
        }
      }
    })
  }
}
